"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _find = _interopRequireDefault(require("lodash/find"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _get = _interopRequireDefault(require("lodash/get"));
var _Player2 = _interopRequireDefault(require("../models/Player"));
var _hlsEvents = _interopRequireDefault(require("../hlsjs/constants/hlsEvents"));
var _hlsTags = _interopRequireDefault(require("../hlsjs/constants/hlsTags"));
var _logging = require("../constants/logging");
var _debugger = _interopRequireDefault(require("../../debugger"));
var _logCategoryActionLabel = _interopRequireDefault(require("../../loggers/logCategoryActionLabel"));
var _handleInstreamError = _interopRequireDefault(require("../utils/handleInstreamError"));
var _playerName = _interopRequireDefault(require("../constants/playerName"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle */
var INSTREAM_AD_META_END = 'X-TUNEIN-AD-EVENT="END"';
var INSTREAM_AD_META_START = 'X-TUNEIN-AD-EVENT="START"';
var TIME_UNTIL_AUTO_REQUEST = 3000;
var InstreamAdPlayer = exports["default"] = /*#__PURE__*/function (_Player) {
  (0, _inherits2["default"])(InstreamAdPlayer, _Player);
  function InstreamAdPlayer(hlsjsPlayer, timeout, isInstreamLoggingEnabled, tuner) {
    var _this;
    (0, _classCallCheck2["default"])(this, InstreamAdPlayer);
    _this = _callSuper(this, InstreamAdPlayer, [_playerName["default"].InstreamAdPlayer]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onPlayHandler", function () {
      _this._removeFragmentTagListener();
      _this._requestTrackingData();

      // Since the tracking url is being manually requested here,
      // the timeout is used to ignore the tags to avoid
      // _requestTrackingData being trigged by the tags at the same time
      setTimeout(_this._addFragmentTagListener, TIME_UNTIL_AUTO_REQUEST);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fragmentTagHandler", function (eventName, resp) {
      var hasDateRangeTag = (0, _find["default"])(resp.frag.tagList, function (tag) {
        return tag[0] === _hlsTags["default"].DATERANGE;
      });
      if (!hasDateRangeTag) {
        return;
      }
      var tagMeta = hasDateRangeTag[1];
      if (!tagMeta) {
        return;
      }

      // AD HAS POTENTIALLY BEEN CUT OFF (FORCE UPDATE)
      if (tagMeta.indexOf(INSTREAM_AD_META_END) >= 0) {
        _this._requestTrackingData(true);
        return;
      }

      // AD DATA IS AVAILABLE
      if (tagMeta.indexOf(INSTREAM_AD_META_START) >= 0) {
        _this._requestTrackingData();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_removeFragmentTagListener", function () {
      _this.hlsjsPlayer.off(_hlsEvents["default"].FRAG_LOADED, _this._fragmentTagHandler);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_addFragmentTagListener", function () {
      _this.hlsjsPlayer.on(_hlsEvents["default"].FRAG_LOADED, _this._fragmentTagHandler);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parseCookieString", function (str, name) {
      var splitReadyStr = "; ".concat(str);
      var parts = splitReadyStr.split('; ' + name + '=');
      return parts.length === 2 ? parts.pop().split(';').shift() : undefined;
    });
    _this.hlsjsPlayer = hlsjsPlayer;
    _this.timeout = timeout;
    _this.isInstreamLoggingEnabled = isInstreamLoggingEnabled;
    _this.trackingUrl = null;
    _this.tuner = tuner;
    return _this;
  }
  (0, _createClass2["default"])(InstreamAdPlayer, [{
    key: "on",
    value: function on(event, callback) {
      this.hlsjsPlayer.on(event, callback);
      this.addListener(event, callback);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      this.hlsjsPlayer.off(event, callback);
      this.removeListener(event, callback);
    }
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, format, position, trackingUrl) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.trackingUrl = trackingUrl;
              _context.next = 4;
              return this.hlsjsPlayer.load(url, format);
            case 4:
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              (0, _handleInstreamError["default"])(_context.t0, _logging.actions.masterUrlTimeout, _logging.actions.masterUrlError, this.isInstreamLoggingEnabled);
              throw _context.t0;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function load(_x, _x2, _x3, _x4) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "play",
    value: function play() {
      return this.hlsjsPlayer.play().then(this._onPlayHandler)["catch"](_noop["default"]);
    }
  }, {
    key: "pause",
    value: function pause() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.stop();
    }
  }, {
    key: "unload",
    value: function unload() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.unload();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._removeFragmentTagListener();
      return this.hlsjsPlayer.destroy();
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.hlsjsPlayer.getPlaybackRate();
    }
  }, {
    key: "canChangePlaybackRate",
    value: function canChangePlaybackRate() {
      return this.hlsjsPlayer.canChangePlaybackRate();
    }
  }, {
    key: "changePlaybackRate",
    value: function changePlaybackRate(rate) {
      this.hlsjsPlayer.changePlaybackRate(rate);
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.hlsjsPlayer.setVolume(volume);
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.hlsjsPlayer.getVolume();
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.hlsjsPlayer.setTitle(title);
    }
  }, {
    key: "getTimes",
    value: function getTimes() {
      return this.hlsjsPlayer.getTimes();
    }
  }, {
    key: "requestInstreamAds",
    value: function requestInstreamAds() {
      this._requestTrackingData();
    }
  }, {
    key: "_requestTrackingData",
    value: function () {
      var _requestTrackingData2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var forceUpdate,
          response,
          ads,
          hasAds,
          playerTime,
          adMetadata,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              forceUpdate = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              _context2.prev = 1;
              _context2.next = 4;
              return _axios["default"].get(this.trackingUrl, {
                timeout: this.timeout
              });
            case 4:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 7;
                break;
              }
              _context2.t0 = {};
            case 7:
              response = _context2.t0;
              ads = (0, _get["default"])(response, 'data.avails[0].ads', []);
              hasAds = ads.length > 0;
              if (!hasAds && this.isInstreamLoggingEnabled) {
                (0, _logCategoryActionLabel["default"])({
                  action: _logging.actions.trackingURLEmpty
                });
              }
              playerTime = this.getTimes() || {};
              adMetadata = _objectSpread({
                playerPosition: playerTime.elapsedSeconds,
                forceUpdate: forceUpdate
              }, response.data);
              this.tuner.trigger(this.tuner.events.instreamAd, adMetadata);
              _context2.next = 20;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t1 = _context2["catch"](1);
              (0, _handleInstreamError["default"])(_context2.t1, _logging.actions.trackingURLTimeout, _logging.actions.trackingURLError, this.isInstreamLoggingEnabled);
              _debugger["default"].log('an error occurred while polling for ads', _context2.t1);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 16]]);
      }));
      function _requestTrackingData() {
        return _requestTrackingData2.apply(this, arguments);
      }
      return _requestTrackingData;
    }()
  }]);
  return InstreamAdPlayer;
}(_Player2["default"]);
//# sourceMappingURL=InstreamAdPlayer.js.map